import React, { useEffect, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import { useLocation } from 'react-router-dom';
import { useSponsors } from '../hooks/useSupabase';
import ImageWithFallback from './ImageWithFallback';

const PORTAL_ID='aox-context-sponsors';
const placementForPath=(path)=>{
  if(path==='/matches'||path.startsWith('/matches/')) return 'matches';
  if(path==='/team'||path.startsWith('/team/player/')) return 'team';
  if(path==='/academy'||path==='/academy-registration') return 'academy';
  if(path==='/media'||path==='/news') return 'media';
  return null;
};
const isCurrentlyActive=(sponsor)=>{
  if(sponsor.is_active===false) return false;
  const today=new Date().toISOString().slice(0,10);
  if(sponsor.start_date&&sponsor.start_date>today) return false;
  if(sponsor.end_date&&sponsor.end_date<today) return false;
  return true;
};

const SponsorStrip=({placement})=>{
  const {data}=useSponsors();
  const sponsors=useMemo(()=>((data||[])
    .filter(isCurrentlyActive)
    .filter(s=>(s.placements||[]).includes(placement))
    .sort((a,b)=>Number(Boolean(b.featured))-Number(Boolean(a.featured))||(a.sort_order||0)-(b.sort_order||0))
    .slice(0,6)),[data,placement]);
  if(!sponsors.length) return null;
  return <section className="border-y border-slate-200 bg-white py-8" data-sponsor-placement={placement}>
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="mb-5 text-center"><div className="text-xs font-black uppercase tracking-[0.18em] text-primary-600">Με την υποστήριξη</div><h3 className="mt-1 text-xl font-black text-slate-900">Οι συνεργάτες δίπλα στην ομάδα</h3></div>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">{sponsors.map(s=><a key={s.id} href={s.url||undefined} target={s.url?'_blank':undefined} rel={s.url?'noopener noreferrer':undefined} className="group flex min-h-28 flex-col items-center justify-center rounded-2xl border border-slate-100 bg-slate-50 p-4 text-center shadow-sm transition hover:-translate-y-0.5 hover:shadow-md">
        <div className="flex h-14 w-full items-center justify-center"><ImageWithFallback src={s.image_url} alt={s.name} className="max-h-14 max-w-full object-contain" fallback={<span className="text-sm font-black text-slate-500">{s.name}</span>}/></div>
        <div className="mt-2 text-xs font-black text-slate-800">{s.name}</div>{s.tagline&&<div className="mt-1 line-clamp-2 text-[10px] leading-tight text-slate-500">{s.tagline}</div>}
      </a>)}</div>
    </div>
  </section>;
};

const SponsorPlacementPortal=()=>{
  const location=useLocation();
  const placement=placementForPath(location.pathname);
  const [node,setNode]=useState(null);
  useEffect(()=>{
    document.getElementById(PORTAL_ID)?.remove(); setNode(null);
    if(!placement) return;
    let cancelled=false,tries=0,timer;
    const mount=()=>{if(cancelled)return;const main=document.querySelector('main');if(main){let el=document.getElementById(PORTAL_ID);if(!el){el=document.createElement('div');el.id=PORTAL_ID;main.appendChild(el);}setNode(el);return;}if(++tries<30)timer=setTimeout(mount,100);};
    mount(); return()=>{cancelled=true;if(timer)clearTimeout(timer);document.getElementById(PORTAL_ID)?.remove();setNode(null);};
  },[location.pathname,placement]);
  return node&&placement?createPortal(<SponsorStrip placement={placement}/>,node):null;
};
export default SponsorPlacementPortal;
